import Clock from './Clock'

export default Clock
// eslint-disable-next-line import/export
export * from './Clock'
